'use client';

import { LoadingSpinner } from '../LoadingSpinner';

import styles from './InlineButton.module.scss';

type InlineButtonProps = {
  children: React.ReactNode;
  ariaLabel?: string;
  type?: 'button' | 'submit' | 'reset';
  isLoading?: boolean;
  disabled?: boolean;
  onClick?: () => void;
  center?: boolean;
  style?: React.CSSProperties;
};

export function InlineButton({
  children,
  ariaLabel,
  type = 'button',
  isLoading = false,
  disabled = false,
  onClick = () => {},
  center = false,
  style = {},
}: InlineButtonProps) {
  return (
    <div
      style={{
        display: 'flex',
        justifyContent: center ? 'center' : 'flex-start',
        alignItems: center ? 'center' : 'flex-start',
      }}
    >
      <button
        type={type}
        aria-label={ariaLabel}
        onClick={onClick}
        disabled={disabled || isLoading}
        className={styles.inlineButton}
        style={{
          cursor: disabled || isLoading ? 'not-allowed' : 'pointer',
          ...style,
        }}
      >
        {isLoading ? <LoadingSpinner size={14} /> : children}
      </button>
    </div>
  );
}
